import { useEffect } from "react"

import { useAppState } from "../../context/appStateContext"
import { PurchasProvider } from "../../context/purchaseContext"
import {
  UltimateAlertsProvider,
  useUltimateAlerts,
} from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import styles from "./ExpirationPaywall.module.scss"
import {
  ExpirationProvider,
  useExpiration,
} from "../../context/expirationContext"
import ExpirationWarmup from "./ExpirationWarmup/ExpirationWarmup"
import UltimateSubfeaturesPopups from "../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import ExpirationPricingSelection from "./ExpirationPricingSelection/ExpirationPricingSelection"
import ToggleUltimateButton from "./ToggleUltimateButton/ToggleUltimateButton"
import Svg from "../../utils/svg"
import FeatureList from "../../components/FeatureList/FeatureList"
import Terms from "../../components/Terms/Terms"
import native from "../../native/native"
import UltimateBackground from "../../components/UltimateBackground/UltimateBackground"
import ComparePlansSheet from "../../components/ComparePlansSheet/ComparePlansSheet"
import ExpirationComparePlansButton from "./ExpirationComparePlansButton/ExpirationComparePlansButton"
import TwoStepPaywall from "../TwoStepPaywall/TwoStepPaywall"

const ExpirationPaywall = () => {
  const { actions } = useAppState()

  useEffect(() => {
    actions.setFooterInsetColor("var(--subscription-background)")
  }, [])

  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <TwoStepPaywall
          MainPage={<Content />}
          WarmupPage={<ExpirationWarmup />}
        />
        <UltimateSubfeaturesPopups />
        <ComparePlansSheet />
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

const Content = () => {
  const expirationState = useExpiration().state
  const { actions } = useAppState()
  const comparePlanActions = useUltimateAlerts().actions

  actions.setHeaderInsetColor("var(--subscription-background)")

  useEffect(() => {
    comparePlanActions.setShowBasicTitle(true)
  })

  if (expirationState.isUltimate) {
    document.documentElement.setAttribute("expiration-selection", "ultimate")
  } else {
    document.documentElement.setAttribute("expiration-selection", "")
  }

  return (
    <>
      <div className={styles.scrollableList}>
        <div className={styles.mainContent}>
          <Header />
          <ExpirationPricingSelection />
          <div style={{ marginTop: 4 }} />
          <ToggleUltimateButton />
          <div style={{ marginTop: 16 }} />
          <FeatureList />
          <div style={{ marginTop: 24 }} />
        </div>
        {expirationState.isUltimate && <UltimateBackground forceVisible />}
        <Footer />
      </div>
    </>
  )
}

const Header = () => {
  const expirationState = useExpiration().state
  const isUltimate = expirationState.canToggleUltimate == false
  const strings = useStrings().expiration
  const title = isUltimate ? strings.titleUltimate : strings.titlePremium
  const subtitle = isUltimate
    ? strings.subtitleUltimate
    : strings.subtitlePremium

  return (
    <div className={styles.headerContainer}>
      <ExpirationComparePlansButton className={styles.comparePlans} />
      <div className={styles.headerIcon}>
        {expirationState.isUltimate ? (
          <Svg.UltimateBadge />
        ) : (
          <Svg.PremiumBadge />
        )}
      </div>
      <label className={styles.title}>{title}</label>
      <label className={styles.subtitle}>{subtitle}</label>
    </div>
  )
}

const Footer = () => {
  const strings = useStrings().expiration

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerContentContainer}>
        <button
          className={styles.basicButton}
          onClick={() => {
            native.postNativeEvent("close")
          }}
        >
          {strings.basicButton}
        </button>
        <label className={styles.basicTitle}>{strings.basicTitle}</label>
        <label className={styles.basicDescription}>
          {strings.basicDescription}
        </label>
        <Terms />
      </div>
    </div>
  )
}

export default ExpirationPaywall
